import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { emailCronConfigActions } from '../../../../store';

import type { AppDispatch, RootState } from '../../../../store';

// Email-cron Redux wiring for the Dashboard's Email Reports tab (list + the
// inline enable/disable toggle), so the dashboard config/columns stay
// dispatch-free and the component doesn't use react-redux for this feature.
export const useEmailReports = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  const emailReports = useSelector((s: RootState) => s.emailCronConfigs.list);
  const loading = useSelector((s: RootState) => s.emailCronConfigs.loading);

  const fetchEmailReports = useCallback(
    () => dispatch(emailCronConfigActions.getList({ getAccessTokenSilently })),
    [dispatch, getAccessTokenSilently],
  );

  const toggleEnabled = useCallback(
    async (id: number, enabled: boolean) => {
      try {
        // update.fulfilled patches this row into state.list, so the table
        // reflects the new value without an extra refetch.
        await dispatch(
          emailCronConfigActions.update({ id, data: { enabled }, getAccessTokenSilently }),
        ).unwrap();
      } catch {
        // Error toast handled by the slice's rejected matcher.
      }
    },
    [dispatch, getAccessTokenSilently],
  );

  return { emailReports, loading, fetchEmailReports, toggleEnabled };
};
